export const ensureEnding = (text: string, ending = '.') => (text.endsWith(ending) ? text : text.trimEnd() + ending);
